import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE--------------------------
import Card from "../../../../Base/Components/Card/Card";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import ReusableDialog from "../../../../Base/Components/Dialog/ReusableDialog";
import { toastShow } from "../../../../Base/Services/ToastService";
import { downloadFile } from "../../../../Base/Services/ArchivosService";

// ------------------- CONSULTAS A LA API---------------------------
import { descargarArchivoPrivate, getCustomers, getEnlaceInscripcion, postChangeEstadoClientes, updateEnlaceInscripcion,sendEmailInscripcion,} from "../../../../API/Compras/Customers/CustomerRequests";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import CrudCustomersModal from "./ModalCustomers/CrudCustomersModal";
import CompradoresDialog from "./CustomerDetails/CompradoresDialog";

export const CustomerScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [customers, setCustomers] = useState("");
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [dialogCustomersD, setDialogCustomersD] = useState(false);
  const [showDialogInscripcion, setShowDialogInscripcion] = useState(false);
  const [idioma, setIdioma] = useState('es');
  const [proveedorMail, setProveedorMail] = useState({});
  const [correoAEviar, setCorreoAEviar] = useState([]);
  const [enlace, setEnlace] = useState('');
  const [estados, setEstados] = useState([]);

  const getInfo = async () => {
    setLoading(true);
    const cust = await getCustomers();
    const estadosTempo = await getEstadosCategory('General')
    setEstados(estadosTempo?.filter(i=> i?.IdStatus === 5 || i?.IdStatus === 6))
    console.log("CLIENTES RECIBIDOS:", cust);

    if(cust?.length > 0){
        console.log("PRIMER CLIENTE:", cust[0]);
    }
    setCustomers(cust);
    setLoading(false);
  };

  const ChangeEstadoEdicion = (IdCustomer, Estado) => {
    updateEnlaceInscripcion({ IdCustomer, Estado });
    const tempo = customers.map((item) => {
      if (item.IdCustomer === IdCustomer) {
        item.esEditable = Estado;
        toastShow( toast, "success", 'Actualizado', "Se actualizó el estado de edición del enlace de inscripción del cliente" );
      }
      return item;
    });
    setCustomers(tempo);
  };

  const cambiarEstadoCliente = async (IdEstado, IdCustomers) => {
    const result = await postChangeEstadoClientes({IdEstado, IdCustomers});
    toastShow(toast, "success", 'Actualizado', "Estado cambiado exitosamente");
    getInfo();
  }

  const changeEstado = ({ data, api }) => {
    return <div>
          <Dropdown
            value={estados.filter(e => e.IdStatus === data.IdEstado)[0]}
            options={estados}
            optionLabel="StatusName"
            filter
            filterBy="StatusName"
            style={{ width: '100%' }}
            onChange={(e) => {
             let changes = []
             if(selected.length > 0 ){
               changes = selected.map(item => {
                return {
                  IdCustomer: item.IdCustomer,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName
                }
               })
             }
             else{
               changes.push({
                 IdCustomer: data.IdCustomer,
                 IdStatus: e.value.IdStatus,
                 StatusName: e.value.StatusName
               })
             }
              confirmDialog({
                message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Clientes ?`,
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                  let IdClientes = changes.map(item => item.IdCustomer);
                  cambiarEstadoCliente(e.value.IdStatus, IdClientes.toString());
                  api.stopEditing();
                },
                reject: () => {
                  getInfo();
                }
              })
            }}
          />
        </div>
 }

  const DescargarArchivoFun = async (codigo, nombre, url) => {
    const a = await descargarArchivoPrivate(codigo, nombre, url);
    downloadFile(a, nombre);
  };

  const colums = [
    //GENERAL
    {
      headerName: "Información General",
      headerNameEn: "General Information",
      children: [
        {
          field: "IdCustomer",
          header: "ID",
          className: "XXsmall",
          hidden: userAuth.IdRol === 1,
        },
        {
          field: "DateCreate",
          headerEn: "Date Create",
          header: "Fecha Creado",
          className: "medium",
          Format: "Date",
          align: "Center",
        },
        {
          header: "Estado",
          headerEn: "Status",
          field: "IdStatus",
          className: "Xsmall",
          Format: "Estado",
          cellEditor: changeEstado,
          body: (rowData) => ({
            ID: rowData.StatusName,
            Estado: rowData.StatusName,
          }),
          // editable: [1, 6, 17].includes(userAuth.IdRol),
        },
        {
          field: "CodigoCliente",
          header: "Código",
          headerEn: "Code",
          className: "small",
          Format: "Modal",
          Sumary: "count",
          onCellDoubleClicked: (rowData) => {
            if(rowData?.data?.IdCustomer){
              setShowDialog(true);
              setSelected(rowData?.data);
            }
          },
        },
        {
          field: "CustomerName",
          header: "Compañia",
          headerEn: "Company",
          className: "Xlarge",
          onCellDoubleClicked: (rowData) => {
            if(rowData?.data?.IdCustomer){
              setShowDialog(true);
              setSelected(rowData?.data);
            }
          },
        },
        {
          field: "RTN",
          header: "RTN",
          className: "small",
        },
        {
          field: "TipoPagoCliente",
          header: "Tipo de Pago Clientes",
          headerEn: "Customer payment type",
          className: "medium",
        },
        {
          field: "NombreTipoPago",
          header: "Tipo Pago",
          headerEn: "Payment Type",
          className: "small",
        },
        {
          field: "CreditLimit",
          header: "Límite de crédito",
          headerEn: "Credit Limit",
          className: "small",
          Format: "Currency",
        },
        {
          field: "TermName",
          header: "Términos",
          headerEn: "Payment",
          className: "medium",
        },
        {
          field: "TermFreightName",
          header: "Términos Flete",
          headerEn: "Freight Terms",
          className: "medium",
        },
        {
          field: "Email",
          header: "Correo",
          headerEn: "Email",
          className: "medium",
        },
        {
          field: "Address",
          headerEn: "Address",
          header: "Dirección",
          className: "large",
        },
        {
          field: "CountryName",
          header: "Pais",
          headerEn: "Country",
          className: "medium",
        },

        // Nuevas columnas añadidas
        {
          field: "PrincipalActividadEconomica",
          header: "Actividad Económica",
          headerEn: "Economic Activity",
          className: "medium",
        },
        {
          field: "CasaMatriz",
          header: "Casa Matriz",
          headerEn: "Headquarters",
          className: "medium",
        },
        {
          field: "DireccionCasaMatriz",
          header: "Dirección Casa Matriz",
          headerEn: "Headquarters Address",
          className: "medium",
        },
        {
          field: "BilledToAddress",
          header: "Dirección de Facturación",
          headerEn: "Invoices to be Billed To",
          className: "medium",
        },
      ],
    },
    {
      field: "PorcentajePenalizacion",
      header: "% Penalización",
      headerEn: "Penalty %",
      className: "medium",
    },

    //Representante
    {
      headerName: "Representante Legal",
      headerNameEn: "Legal Representative",
      children: [
        {
          field: "NombreRepresentanteLegal",
          header: "Nombre",
          headerEn: "Name",
          className: "medium",
        },
        {
          field: "IdentificacionRepresentante",
          header: "Identificación",
          headerEn: "Identification",
          className: "medium",
        },
        {
          field: "TelefonoRepresentante",
          header: "Teléfono",
          headerEn: "Phone",
          className: "medium",
        },
        {
          field: "CorreoRepresentanteLegal",
          header: "Correo",
          headerEn: "Email",
          className: "medium",
        },
        {
          field: "FileRepresentante",
          header: "Archivo ID",
          headerEn: "File ID",
          className: "large",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileRepresentante ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileRepresentante, "Representante")}
                  tooltip="Identificación Representante"
                  tooltipOptions={{position: "top"}}
                />
              </div>
            ) : (
              ""
            ),
        },
      ],
    },

    //Cuentas por Pagar
    {
      headerName: "Cuentas por Pagar",
      headerNameEn: "Accounts Payable",
      children: [
        {
          field: "ContactoCuentasPorPagar",
          header: "Nombre",
          headerEn: "Name",
          className: "medium",
        },
        {
          field: "CorreoCuentasPorPagar",
          header: "Correo",
          headerEn: "Email",
          className: "medium",
        },
        {
          field: "TelefonoCuentasPorPagar",
          header: "Teléfono",
          headerEn: "Phone",
          className: "medium",
        },
      ],
    },

    //Contacto Finanzas
    {
      headerName: "Contacto Finanzas",
      headerNameEn: "Contact Finance",
      children: [
        {
          field: "NombreContactoFin1",
          header: "Nombre",
          headerEn: "Name",
          className: "medium",
        },
        {
          field: "CorreoContactoFin1",
          header: "Correo",
          header: "Email",
          className: "medium",
        },
        {
          field: "TelefonoContactoFin1",
          header: "Teléfono",
          headerEn: "Phone",
          className: "medium",
        },
      ],
    },

    //Referencias Comerciales
    {
      headerName: "Referencias Comerciales",
      children: [
        {
          field: "CompanyRefComercial1",
          header: "Nombre de Compañía",
          headerEn: "Comany Name",
          className: "medium",
        },
        {
          field: "RefNombre1",
          header: "Nombre 1",
          headerEn: "Name 1",
          className: "medium",
        },
        {
          field: "RefCorreo1",
          header: "Referencia Correo 1",
          className: "medium",
        },
        {
          field: "RefTelefono1",
          header: "Telefono 1",
          headerEn: "Phone 1",
          className: "medium",
        },
        {
          field: "FileRefComercial1",
          header: "Archivo Ref 1",
          headerEn: "File Ref 1",
          className: "large",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileRefComercial1 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileRefComercial1, "RefComercial1")}
                  tooltip="Archivo Ref. Comercial 1"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "CompanyRefComercial2",
          header: "Nombre de Compañía",
          headerEn: "Comany Name",
          className: "medium",
        },
        {
          field: "RefNombre2",
          header: "Nombre 2",
          headerEn: "Name 2",
          className: "medium",
        },
        {
          field: "RefCorreo2",
          header: "Correo 2",
          header: "Email 2",
          className: "medium",
        },
        {
          field: "RefTelefono2",
          header: "Telefono 2",
          headerEn: "Phone 2",
          className: "medium",
        },
        {
          field: "FileRefComercial2",
          header: "Archivo Ref 2",
          headerEn: "File Ref 2",
          className: "large",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileRefComercial2 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileRefComercial2, "RefComercial2")}
                  tooltip="Archivo Ref. Comercial 1"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
      ],
    },

    //Referencias Bancarias
    {
      headerName: "Referencias Bancarias",
      headerNameEn: "Bank References",
      children: [
        {
          field: "BankName1",
          header: "Nombre Banco 1",
          headerEn: "Bank Name 1",
          className: "medium",
        },
        {
          field: "NombreRefBancaria1",
          header: "Nombre 1",
          headerEn: "Name 1",
          className: "medium",
        },
        {
          field: "TelefonoRefBancaria1",
          header: "Teléfono 1",
          headerEn: "Phone 1",
          className: "medium",
        },
        {
          field: "CorreoRefBancaria1",
          header: "Correo Ref. 1",
          headerEn: "Email Ref. 1",
          className: "medium",
        },
        {
          field: "FileRefBanc1",
          header: "Archivo Ref 1",
          headerEn: "File Ref 1",
          className: "large",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileRefBanc1 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileRefBanc1, "RefBanc1")}
                  tooltip="Archivo Ref. Bancaria 1"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },

        {
          field: "BankName2",
          headerEn: "Bank Name 2",
          header: "Nombre Banco 2",
          className: "medium",
        },
        {
          field: "NombreRefBancaria2",
          header: "Nombre 2",
          headerEn: "Name 2",
          className: "medium",
        },
        {
          field: "TelefonoRefBancaria2",
          header: "Teléfono 2",
          headerEn: "Phone 2",
          className: "medium",
        },
        {
          field: "CorreoRefBancaria2",
          header: "Correo Ref. 2",
          headerEn: "Email Ref. 2",
          className: "medium",
        },
        {
          field: "FileRefBanc2",
          header: "Archivo Ref 2",
          headerEn: "File Ref 2",
          className: "large",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileRefBanc2 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileRefBanc2, "RefBanc2")}
                  tooltip="Archivo Ref. Bancaria 2"
                  tooltipOptions={{position: "top"}}
                />
              </div>
            ) : (
              ""
            ),
        },
      ],
    },

    //Documentacion
    {
      headerName: "Archivos",
      headerNameEn: "Files",
      children: [
        {
          field: "FileBIC",
          header: "Archivo BIC",
          headerEn: "File BIC",
          className: "large",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileBIC ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileBIC, "BIC")}
                  tooltip="Descargar BIC"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "FileFactura",
          header: "Archivo Factura",
          headerEn: "File Invoice",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileFactura ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileFactura, "Factura")}
                  tooltip="Descargar Factura"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "FilePermisoOpera",
          header: "Archivo Permiso Operación",
          headerEn: "File Operation Permission",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FilePermisoOpera ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FilePermisoOpera, "Permiso")}
                  tooltip="Descargar Permiso"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "FileConstitucion",
          header: "Archivo Constitución",
          headerEn: "Constitution Archive",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileConstitucion ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileConstitucion, "Escritura")}
                  tooltip="Descargar Escritura"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },

        {
          field: "FileRegistroExonerado",
          header: "Archivo Registro Exonerado",
          headerEn: "Exonerated Registry File",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileRegistroExonerado ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileRegistroExonerado, "Registro")}
                  tooltip="Descargar Registro Exónerado"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "FileEstadosFinancieros",
          header: "Archivo Estados Financieros",
          headerEn: "Financial Statements File",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileEstadosFinancieros ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileEstadosFinancieros, "EstadosFin")}
                  tooltip="Descargar Estados Financieros"
                  tooltipOptions={{
                    position: "top",
                  }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "FileCertificadoAmbiental",
          header: "Certificado Ambiental",
          headerEn: "File Invoice",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileCertificadoAmbiental ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileCertificadoAmbiental, "CertificadoA")}
                  tooltip="Descargar Certificado"
                  tooltipOptions={{ position: "top" }}
                />
              </div>
            ) : (
              ""
            ),
        },
        {
          field: "FileCertificadoLaboral",
          header: "Certificado Laboral",
          headerEn: "File Invoice",
          className: "medium",
        },
        {
          field: "",
          filter: false,
          header: "",
          className: "XXsmall",
          Format: "Template",
          body: (rowData) =>
            rowData.FileCertificadoLaboral ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  icon="pi pi-download"
                  className="p-button-text"
                  onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileCertificadoLaboral, "CertificadoL")}
                  tooltip="Descargar Certificado"
                  tooltipOptions={{ position: "top" }}
                />
              </div>
            ) : (
              ""
            ),
        },
      ],
    },

    //Zona Libre
    {
      headerName: "Zona Libre",
      headerNameEn: "Free Zone",
      children: [
        {
          field: "ZonaLibre",
          header: "Zona Libre",
          headerEn: "Free Zone",
          className: "small",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) => (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Checkbox disabled checked={rowData.ZonaLibre} />
            </div>
          ),
        },
        {
          field: "NombreZonaLibre",
          header: "Nombre Zona Libre",
          headerEn: "Free Zone Name",
          className: "medium",
        },
        {
          field: "DireccionZonaLibre",
          header: "Dirección Zona Libre",
          headerEn: "Free Zone Address",
          className: "medium",
        },
      ],
    },
    {
      field: "Incompleta",
      header: "Incompleta",
      filter: true,
      Format: "Template",
      className: "Xsmall",
      headerTooltip: "Inscripción Incompleta",
      body: (rowData) => (
        <div className="d-flex flex-row" style={{ justifyContent: "center" }}>
          <Checkbox
            checked={rowData.Incompleta}
            disabled
            tooltipOptions={{ position: "top" }}
          />
        </div>
      ),
    },
    //Checkbox
    {
      field: "IsContado",
      header: "IsContado",
      className: "Xsmall",
      Format: "Template",
      align: "center",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      body: (rowData) => <Checkbox disabled style={{ marginBottom: 5 }} checked={rowData.IsContado} />,
    },
    {
      field: "BlockFinanzas",
      header: "BlockFinanzas",
      className: "Xsmall",
      Format: "Template",
      align: "center",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      body: (rowData) => <Checkbox disabled style={{ marginBottom: 5 }} checked={rowData.BlockFinanzas} />,
    },

    {
      field: "IdCustomer",
      header: "",
      Format: "Botones",
      filter: false,
      alignFrozen: "right",
      frozen: true,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdCustomer){
              setShowDialog(true);
              setSelected(rowData);
            }
          },
          tooltipOptions: { position: "top", },
        },
        {
          icon: "pi pi-envelope",
          tooltip: "Enviar correo Inscripción",
          onClick: async (rowData) => {
            if(rowData?.IdCustomer){
              setShowDialogInscripcion(true);
              setProveedorMail(rowData);
              setCorreoAEviar(rowData?.Email === ' ' ? [] : [rowData?.Email]);
              const enlaceT = await getEnlaceInscripcion(rowData.IdCustomer, userAuth?.IdUser);
              setEnlace({ enlace: enlaceT[0], Email: correoAEviar, CustomerName: rowData?.CustomerName })
            }
          },
          tooltipOptions: {position: "top",},
        },
        {
          icon: "ri-file-user-line",
          tooltip: "Compradores",
          onClick: (rowData) => {
            if(rowData?.IdCustomer){
              setDialogCustomersD(true);
              setSelected(rowData);
            }
          },
          tooltipOptions: {
            position: "top",
          },
        },
      ],
    },

    {
      field: "",
      header: "",
      headerEn: "",
      filter: false,
      alignFrozen: "right",
      Format: "Template",
      className: "XXsmall",
      body: (rowData) => (
        <div className="d-flex flex-row" style={{ justifyContent: "center" }}>
          <Checkbox
            checked={rowData.esEditable}
            onChange={(e) => {
              if(rowData?.IdCustomer){
               ChangeEstadoEdicion(rowData.IdCustomer, e.target.checked)
              }}
            }
            tooltipOptions={{ position: "top" }}
            tooltip="Habilitar inscripción"
          />
        </div>
      ),
    },
    {
      field: "",
      filter: false,
      header: "",
      className: "XXsmall",
      Format: "Template",
      body: (rowData) =>
        rowData.FileFormatoInscripcion ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              icon="pi pi-download"
              className="p-button-text"
              onClick={() => DescargarArchivoFun(rowData?.CodigoCliente, rowData.FileFormatoInscripcion, "FormatoIns")}
              tooltip= "Descargar formato de inscripción de cliente"
              tooltipOptions={{ position: "top" }}
            />
          </div>
        ) : (
          ""
        ),
    },


    {
      field: "IdCustomer",
      header: "",
      Format: "SplitButton",
      filter: false,
      alignFrozen: "right",
      className: "Xsmall",
      frozen: true,
      Botones: [
        {
          icon: "pi pi-print",
          tooltip: "Formato de Inscripción",
          tooltipOptions: { position: "top" },
          onClick: async (rowData) => {
            if (!rowData?.IdCustomer) {
              toastShow(toast, "warn", "Advertencia", "No se encontró el cliente seleccionado.");
              return;
            }

            try {
              const Token = await getEnlaceInscripcion(rowData.IdCustomer, userAuth?.IdUser);
              const tokenFinal = Array.isArray(Token) ? Token[0] : Token;
              if (!tokenFinal) {
                toastShow(toast, "error", "Error", "No se pudo generar el token del reporte.");
                return;
              }

              const url = `${window.location.origin}${process.env.REACT_APP_ENV}/FormatoInscripcionClientes/${rowData.IdCustomer}/${tokenFinal}/2`;

              window.open(url, rowData.IdCustomer, "height=1200,width=1000");
            } catch (error) {
              console.error("ERROR AL IMPRIMIR CLIENTE:", error);
              toastShow(toast, "error", "Error", "No se pudo generar el reporte del cliente.");
            }
          },
          items: [
            {
              label: "Ingles",
              onClick: async (rowData) => {
                if(rowData?.IdCustomer){
                  const Token = await getEnlaceInscripcion(rowData.IdCustomer, userAuth?.IdUser);
                  const tokenFinal = Array.isArray(Token) ? Token[0] : Token;
                  const url = `${window.location.origin}${process.env.REACT_APP_ENV}/FormatoInscripcionClientes/${rowData.IdCustomer}/${tokenFinal}/1`;
                  window.open(url, rowData.IdCustomer, "height=1200,width=1000");
                }
              },
            },
            {
              label: "Español",
              onClick: async (rowData) => {
                if(rowData?.IdCustomer){
                  const Token = await getEnlaceInscripcion(rowData.IdCustomer, userAuth?.IdUser);
                  const tokenFinal = Array.isArray(Token) ? Token[0] : Token;
                  const url = `${window.location.origin}${process.env.REACT_APP_ENV}/FormatoInscripcionClientes/${rowData.IdCustomer}/${tokenFinal}/2`;
                  window.open(url, rowData.IdCustomer, "height=1200,width=1000");
                }
              },
            },
          ],
        },
      ],
    },
  ];

  const table = {
    Columns: colums,
    Data: customers,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: (e) => {},
  };

  const enviarCorreoInscripcion = async () => {
    if (!correoAEviar || correoAEviar.length === 0) {
      toastShow(toast, "warn", "Advertencia", "Debe ingresar al menos un correo.");
      return;
    }

    if (!enlace?.enlace) {
      toastShow(toast, "error", "Error", "No se encontró el enlace de inscripción.");
      return;
    }

    const linkFinal = `${window.location.origin}${process.env.REACT_APP_ENV}/inscripcionClientes/${idioma}/${enlace.enlace}`;

    const body = {
      to: correoAEviar.join(","),
      subject: "Enlace de inscripción de cliente",
      html: `
        <div>
          <p>Estimado cliente,</p>
          <p>Por favor complete su inscripción en el siguiente enlace:</p>
          <p><a href="${linkFinal}" target="_blank">${linkFinal}</a></p>
          <p>Saludos.</p>
        </div>
      `,
    };

    const resp = await sendEmailInscripcion(body, enlace.enlace);

    if (resp) {
      toastShow(toast, "success", "Correo enviado", "El correo fue enviado correctamente.");
      setShowDialogInscripcion(false);
    } else {
      toastShow(toast, "error", "Error", "No se pudo enviar el correo.");
    }
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "customer", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "customer", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              onClick={() => {
                setShowDialog(true);
                setSelected([]);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && (
        <CrudCustomersModal
          toastRef={toast}
          customerDialog={showDialog}
          customer={selected}
          setCustomerDialog={setShowDialog}
          getCustomer={getInfo}
          modo={selected?.IdCustomer ? "Editar" : "Crear"}
        />
      )}

      {dialogCustomersD && (
        <CompradoresDialog
          dialogCustomersD={dialogCustomersD}
          selected={selected}
          setDialogCustomersD={setDialogCustomersD}
        />
      )}

      {showDialogInscripcion && (
        <ReusableDialog
          visible={showDialogInscripcion}
          onHide={() => {          
            setShowDialogInscripcion(false);
            setProveedorMail(undefined)
          }}
          header={"Enviar Correo a Cliente"}
          ejecutar={enviarCorreoInscripcion}
          Id={proveedorMail?.IdCustomer}
          enlace={`${window.location.origin}${process.env.REACT_APP_ENV}/inscripcionClientes/${idioma}/${enlace?.enlace}`}
          correoAEnviar={correoAEviar}
          setCorreoAEnviar={setCorreoAEviar}
          idioma={idioma}
          setIdioma={setIdioma}
        />
      )}
    </div>
  );
};

export default CustomerScreen;
